import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getGalleryInner } from "../../Service/Api";
import FilterContainer from "../../utlis/FilterContainer";
import LazyLoad from "react-lazyload";
import Breadcrumb from "../../Component/Breadcrumb";

function GalleryInner() {
  const navigate = useNavigate();

  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(8);

  // ✅ Fetch gallery data (no loading/error)
  const { data: galleryData = [] } = useQuery({
    queryKey: ["galleryInner"],
    queryFn: getGalleryInner,
  });

  // ✅ Dummy gallery fallback
  const galleryDummyHome = [
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
    {
      title: "Gallery Title",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png",
    },
  ];

  // ✅ Use dummy data if API fails or returns empty
  const galleryList =
    Array.isArray(galleryData) && galleryData.length > 0
      ? galleryData
      : galleryDummyHome;

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthOptions = ["All", ...monthNames];

  const yearRanges = [
    ...new Set(
      galleryList
        .map((item) => {
          const d = new Date(item.date);
          return !isNaN(d) ? d.getFullYear().toString() : null;
        })
        .filter(Boolean)
    ),
  ].sort((a, b) => b - a);

  // ✅ Apply filters (year, month, search)
  const filterData = galleryList.filter((item) => {
    const date = new Date(item.date);
    const itemYear = date.getFullYear().toString();
    const itemMonth = monthNames[date.getMonth()];

    const matchYear = selectedYear === "All" || itemYear === selectedYear;
    const matchMonth = selectedMonth === "All" || itemMonth === selectedMonth;

    const matchSearch =
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchYear && matchMonth && matchSearch;
  });

  const visibleItems = filterData.slice(0, visibleCount);

  const handleLoadMore = () => setVisibleCount((prev) => prev + 8);

  return (
    <>
      <Breadcrumb>Gallery / PhotoGallery</Breadcrumb>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Gallery</h1>
            </div>
          </div>

          {/* ===== Filters ===== */}
          <FilterContainer
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            yearRanges={yearRanges}
            monthOptions={monthOptions}
            totalCount={filterData.length}
          />

          {/* ===== Gallery Grid ===== */}
          <div className="row years year2024 showYear">
            {visibleItems.length > 0
              ? visibleItems
                  .filter(
                    (item) => !item.category || item.category === "PhotoGallery"
                  )
                  .map((item, index) => {
                    const date = new Date(item.date);
                    const day = isNaN(date.getDate()) ? "DD" : date.getDate();
                    const month = monthNames[date.getMonth()] || "Mon";

                    return (
                      <div
                        className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 galleryCount"
                        key={index}
                      >
                        <div className="gallery-inner">
                          <div className="gallery-blks">
                            <div className="backDiv"></div>
                            <LazyLoad
                              offset={10}
                              placeholder={
                                <img
                                  src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png"
                                  alt="Loading..."
                                  className="img-fluid"
                                />
                              }
                            >
                              <img
                                src={
                                  item.attachments && item.attachments[0]
                                    ? `https://webapi.entab.info/api/image/${item.attachments[0]}`
                                    : "https://webapi.entab.info/api/image/SJSKBUP/public/Images/slider1.png"
                                }
                                className="img-fluid"
                                alt={item.title || "Gallery"}
                              />
                            </LazyLoad>
                          </div>

                          <div className="gallery-content">
                            <div className="gallery-date">
                              <h6>
                                {day} <span>{month}</span>
                              </h6>
                              <div className="gall-num">
                                <h5>
                                  <span>Number Of Photos :</span>{" "}
                                  {item.attachments
                                    ? item.attachments.length
                                    : "N/A"}
                                </h5>
                              </div>
                            </div>
                            <div className="gallery-title">
                              <h3>{item.title || "Gallery Title"}</h3>
                            </div>
                            <Link
                              to={`/SubGallery/${item._id || ""}`}
                              className="view-more"
                            >
                              View More <i className="bi bi-arrow-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })
              : // ✅ Dummy fallback UI
                galleryDummyHome.map((data, index) => (
                  <div
                    className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 galleryCount"
                    key={index}
                  >
                    <div className="gallery-inner">
                      <div className="gallery-blks">
                        <div className="backDiv"></div>
                        <img src={data.img} className="img-fluid" alt="Demo" />
                      </div>
                      <div className="gallery-content">
                        <div className="gallery-date">
                          <h6>
                            DD <span>Mon</span>
                          </h6>
                          <div className="gall-num">
                            <h5>
                              <span>Number Of Photos :</span> NO
                            </h5>
                          </div>
                        </div>
                        <div className="gallery-title">
                          <h3>{data.title}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </div>

          {/* ===== Load More Button ===== */}
          {filterData.length > visibleCount && (
            <div className="row">
              <div className="col-12 text-center mt-4">
                <button
                  className="btn load_more_btn px-4 py-2 mainbtn button"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default GalleryInner;
